import { Component, Vue } from 'vue-property-decorator';
import { addDays, convertDateToCustomFormat } from '../../../../util/date-util';
import { getSpecificRoleUser } from '@/util/paid-user-util';
import { namespace } from 'vuex-class';

const appStoreState = namespace('appStore');

@Component({
  methods: {
    convertDateToCustomFormat,
    forwardPlanPricing() {
      this.$router.push('/pricing-plan');
    },
  },
  created() {
    const localStorageUser = JSON.parse(localStorage.getItem('localStorageUser')) || null;
    if (localStorageUser) {
      const { startDatePaid, policyUsers } = localStorageUser;
      if (startDatePaid) {
        let resetDate = new Date(startDatePaid);
        const today = new Date();
        while (resetDate <= today) {
          resetDate = addDays(resetDate, 30);
        }
        this.resetDate = convertDateToCustomFormat(resetDate, 'yyyy.MM.dd');
      }

      if (getSpecificRoleUser() !== 'Ultra' && policyUsers) {
        policyUsers.map(item => {
          if (item.featureIdx === 1) {
            this.deepResearchRemain = item.remain;
            if (this.getIsShowAlertDeepResearch) {
              this.setIsShowAlertDeepResearch(this.deepResearchRemain <= 10);
            }
          }
        });
      } else {
        this.hideAlert();
      }
    } else {
      this.hideAlert();
    }
  },
})
export default class AlertDeepResearch extends Vue {
  @appStoreState.Getter
  getIsShowAlertDeepResearch!: boolean;

  @appStoreState.Mutation
  public setIsShowAlertDeepResearch!: (payload?: boolean) => void;

  deepResearchRemain = 0;
  resetDate = '';

  hideAlert() {
    this.setIsShowAlertDeepResearch(false);
  }
}
